import type { AssessmentResponse, SurveyAnswer } from '~/api/types'

// errMessage는 전역 공통 유틸로 단일화됨. 기존 import 경로(`./utils`) 호환 위해 재export.
export { errMessage } from '~/lib/errors'
// formatDateTime도 공용 date-utils로 단일화. 기존 import 경로(`./utils`) 호환 위해 재export.
export { formatDateTime } from '~/lib/date-utils'

export function assessmentStatusLabel(
    status: AssessmentResponse['status']
): string {
    const labels: Record<AssessmentResponse['status'], string> = {
        collecting: '작성 중',
        scored: '채점 완료',
        reported: '보고서 완료',
    }
    return labels[status]
}

export function toServiceTone(value?: string): string {
    if (!value) return ''
    return value
        .replaceAll('확인해서는 아니 되며', '확인하는 데서 끝나지 않고')
        .replaceAll('아니 되며', '아니며')
        .replaceAll('아니 하여야 하며', '하지 않아야 하며')
        .replaceAll('아니 하여야 한다', '하지 않아야 합니다')
        .replaceAll('아니 하도록', '하지 않도록')
        .replaceAll('하여서는 아니 된다', '하면 안 됩니다')
        .replaceAll('하여야 하며', '해야 하며')
        .replaceAll('하여야 한다', '해야 합니다')
        .replaceAll('반영하여야 한다', '반영해야 합니다')
        .replaceAll('검토하여야 한다', '검토해야 합니다')
        .replaceAll('확인하여야 한다', '확인해야 합니다')
        .replaceAll('관리하여야 한다', '관리해야 합니다')
        .replaceAll('유지하여야 한다', '유지해야 합니다')
}

export function changeCategoryFor(value?: string): string {
    const text = value ?? ''
    if (/원료|식재료|제품|메뉴|레시피|배합/.test(text)) return '제품·원료 변경'
    if (/포장|보관|출하|유통|냉장|냉동/.test(text)) return '포장·보관 변경'
    if (/가열|온도|시간|공정|기준|살균|소독기/.test(text))
        return '공정 기준 변경'
    if (/설비|기계|장비|기구|환풍|배수|배기|온도계/.test(text)) {
        return '시설·설비 변경'
    }
    if (/위치|공간|구역|동선|조리장|작업장/.test(text)) return '공간·동선 변경'
    if (/청소|세척|소독|방충|방서|해충/.test(text)) return '위생관리 기준 변경'
    return '변경 영향 검토'
}

export function displayAnswer(answer: SurveyAnswer | undefined): string {
    if (!answer) return '미답'
    if (answer.unknown) return '모름/해당없음'
    const value = answer.value?.trim()
    if (!value) return '-'
    if (value.toUpperCase() === 'TRUE') return '예'
    if (value.toUpperCase() === 'FALSE') return '아니오'
    return value
}

export function escapeHtml(value: string | number): string {
    // 값이 숫자(예: 체크리스트 item_number는 백엔드에서 int)로 와도 안전하게 문자열화한다.
    // 과거 number.replaceAll 호출로 보고서 빌더가 throw → 보고서가 항상 "데이터 없음"으로 떴다.
    return String(value)
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;')
}
